import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      ADDONS: "Dagligvarer",
      MEALS: "Middager",
      ORDER: "Bestilling",
      CONFIRM_ORDER: "Bekreft bestilling",
    },
    se: {
      ADDONS: "Livsmedel",
      MEALS: "Middagar",
      ORDER: "Beställning",
      CONFIRM_ORDER: "Bekräfta beställning",
    },
    dk: {
      MEALS: "Retter",
      ADDONS: "Dagligvarer",
      ORDER: "Bestilling",
      CONFIRM_ORDER: "Bekræft ordre",
    },
  } as const
)[language];
